// NormalizeURL.tsx
import { Navigate, useLocation } from "react-router-dom";

const NormalizeURL = () => {
	const location = useLocation();
	if (location.pathname !== location.pathname.toLowerCase()) {
		// Case: URL is not lowercase, so force that
		const normalized = location.pathname.toLowerCase() + location.search;
		return <Navigate to={normalized} replace />;
	}

	// Case: URL is already lowercase, and we did not find the targeted route. So Nav to 404.
	return <Navigate to="/404" replace />;
};

export default NormalizeURL;
